export const WIDGET_LOCATION_OF_YOUR_KITS = 'widget-location-of-your-kits';
export const WIDGET_LOCATION_OF_YOUR_KITS_RESULT = `${WIDGET_LOCATION_OF_YOUR_KITS}/result`;
export const WIDGET_LOCATION_OF_YOUR_KITS_ERROR = `${WIDGET_LOCATION_OF_YOUR_KITS}/error`;
